import { PaymentMethod, PaymentStatus } from "../../Enums/RegistrationEnum";
import IGeneralFields from "./IGeneralFileds";

export const PAYMENT_CREATED_FROM = {
  paya: "paya",
  staffAttendee: "staffAttendee",
  staffInvoiceEmail: "staffInvoiceEmail",
  registrationHostFirm: "registrationHostFirm",
} as const;

export type PaymentCreatedFrom =
  (typeof PAYMENT_CREATED_FROM)[keyof typeof PAYMENT_CREATED_FROM];

interface IDiscount {
  discountType: "percentage" | "fixed";
  amount: number;
}

interface IPaymentPerson {
  personId: string;
  attendeeType: "regular" | "sponsor" | "guest" | "speaker" | "invited_guest";
}

export interface IPayment extends IGeneralFields {
  registrationId: string;
  eventId: string;
  person: IPaymentPerson[];
  amount: number;
  currency: string;
  paymentMethod: PaymentMethod;
  paymentDate: number;
  status: PaymentStatus;
  transactionId?: string[];
  discount?: IDiscount;
  reasonCode?: string;
  errorMessage?: string;
  guestPaid?: boolean;
  lastTransactionAmount?: number;
  createdFrom?: PaymentCreatedFrom | string;
}
